// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__2QyEZ","error":"styles_error__Wi5MK"};